<script lang="ts">
  import { _ } from 'svelte-i18n';
  import striptags from 'striptags';
  import AccountNumber from '$components/blocks/club/AccountNumber.svelte';
  import Advantages from '$components/blocks/club/Advantages.svelte';
  import Button from '$components/elements/Button.svelte';
  import ClubInformations from '$components/blocks/club/ClubInformations.svelte';
  import PageHeader from '$components/elements/PageHeader.svelte';
  import PageHeaderText from '$components/elements/PageHeaderText.svelte';
  import PageHeaderTitle from '$components/elements/PageHeaderTitle.svelte';
  import SupportUsBoxContainer from '$components/blocks/club/SupportUsBoxContainer.svelte';
  import SupportUsText from '$components/blocks/club/SupportUsText.svelte';
  import Text from '$components/utils/Text.svelte';
</script>

<svelte:head>
  <title>{striptags($_('page.club.title'))}</title>
</svelte:head>

<PageHeader image="page.club">
  <PageHeaderTitle><Text key="page.club.header.title.part1" /></PageHeaderTitle>
  <PageHeaderTitle><Text key="page.club.header.title.part2" /></PageHeaderTitle>
  <PageHeaderText><Text key="page.club.header.text" /></PageHeaderText>
  <Button type="spacious" icon="arrow-right" iconColor="#fff" href="/klub-bible21/registrace"
    ><Text key="page.club.header.button" /></Button
  >
</PageHeader>

<ClubInformations />
<SupportUsText />
<SupportUsBoxContainer />
<AccountNumber />
<Advantages />
